import { dailySessionNotes } from '../../actions/constant';

const {
  GET_PATIENT_DAILY_SESSION_SUCCESS,
  GET_PATIENT_DAILY_SESSION_FAILURE,
  GET_PATIENT_DAILY_SESSION_LOADING,
  RESET_PATIENT_DAILY_SESSION,
} = dailySessionNotes;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getDailySessionPatientList = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_PATIENT_DAILY_SESSION_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_PATIENT_DAILY_SESSION_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };
    case GET_PATIENT_DAILY_SESSION_LOADING:
      return {
        ...state,
        loading: true,
      };
    case RESET_PATIENT_DAILY_SESSION:
      return intitialstate;

    default:
      return state;
  }
};
